import { Service } from '../service.js';
import { env } from '../env.js';

class DocumentoService extends Service {
    constructor() {
        super();
        this.url = env.baseDocumento
    }

    async getDocumentos(objetoQueryString) {
        const url = `${this.url}documentos?${objetoQueryString}include=arquivos,categoria&fields[arquivos]=id,nome,extensao,mime,tamanho,codigoDeBarras`;
        return super.get(url);
    }

    async downloadById(id, type, filename) {
        const url = `${this.url}arquivos/${id}`;
        return super.downloadFile(url, type, filename);
    }

    async downloadLista(lista) {
        let baseUrl = `${this.url}arquivos/multiplos`;
        let queryParams = lista.map(obj => `id=${obj.id}`).join('&');
        const url = `${baseUrl}?${queryParams}`;
        return super.downloadMultipleFile(url);
    }

    async getCategoriasPersonalizadas() {
        let baseUrl = `${this.url}categorias-de-documentos?page[limit]=50&page[offset]=0`;
        return this.buscarObjeto(baseUrl);
    }

    async hasDocumentoById(id) {
        const baseUrl = `${this.url}documentos?filter[id]=${id}`;
        const response = await this.get(baseUrl);
        return response.data.length != 0;
    }
}

export const documentoService = new DocumentoService()
